// @flow
/* eslint arrow-parens:0 */

import React, { Fragment, PureComponent } from 'react';
import DidItModal from 'app/common/react/components/do/aggregated-pins/did-it/DidItRecommend/DidItModal';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyModal from 'app/common/react/ui/deprecated/LegacyModal';
import withAuthenticatedAction from 'app/common/react/components/limitedLogin/withAuthenticatedAction';
import { track } from 'app/common/lib/react/analytics';

export type DidItButtonProps = {
  onTriedItButtonClick: (event: SyntheticMouseEvent<>) => void,
};

type ChildrenAndThriftComponentTypeProps = {|
  children: Function, // should have a button or trigger that will be passed a clickhandler
  thriftComponentType: number,
|};

export type DidItButtonModalManagerProps = {|
  aggregatedPinDataId: string,
  // TODO(xixia): Come back and consider if this is needed.
  authAction: (Function) => Function,
  isDoneByMe: boolean,
  loggedInUser: {
    id: string,
    username: string,
  },
  onDoneStateChanged?: (stateChanged: boolean) => void, // indicates if isDoneByMe has changed
  onToggleModal?: (isShown: boolean) => void,
  pinId: string,
  pinTitle?: string,
  userDidItDataId?: string,
|};

type Props = {|
  ...DidItButtonModalManagerProps,
  ...ChildrenAndThriftComponentTypeProps,
|};

type State = {| showModal: boolean |};

export class DidItButtonModalManager extends PureComponent<Props, State> {
  static defaultProps = {
    aggregatedPinDataId: '',
  };

  state = { showModal: false };

  onTriedItButtonClick = this.props.authAction(({ event }: { event: SyntheticMouseEvent<> }) => {
    if (event) {
      event.stopPropagation();
    }

    this.handleModalStateChange(true);

    track(PCONST.thrift.EventType.CLICK, {
      view: PCONST.thrift.ViewType.PIN_DID_IT,
      component: this.props.thriftComponentType,
      element: PCONST.thrift.ElementType.DID_IT_INPUT_BUTTON,
      objectId: this.props.pinId,
      is_create: !this.props.isDoneByMe,
    });
  });

  handleHideModal = () => {
    this.handleModalStateChange(false);

    track(PCONST.thrift.EventType.CLICK, {
      view: PCONST.thrift.ViewType.PIN_DID_IT,
      component: PCONST.thrift.ComponentType.DID_IT_MODAL_FULL_SHEET,
      element: PCONST.thrift.ElementType.CLOSE_BUTTON,
      objectId: this.props.pinId,
    });
  };

  onModalDoneStateChanged = (stateChanged: boolean) => {
    this.handleModalStateChange(false, stateChanged);
  };

  handleModalStateChange = (open: boolean, doneByMeChanged?: boolean) => {
    const { onDoneStateChanged, onToggleModal } = this.props;

    this.setState({ showModal: open }, () => {
      // trigger the callback (after state syncs)
      if (!open) {
        if (onDoneStateChanged) {
          onDoneStateChanged(typeof doneByMeChanged === 'boolean' ? doneByMeChanged : false);
        }
      }

      if (onToggleModal) {
        onToggleModal(open);
      }
    });
  };

  render() {
    const {
      aggregatedPinDataId,
      isDoneByMe,
      loggedInUser,
      pinId,
      pinTitle,
      userDidItDataId,
    } = this.props;

    return (
      <Fragment>
        {this.props.children({ onTriedItButtonClick: this.onTriedItButtonClick })}
        {this.state.showModal ? (
          <LegacyModal onHide={this.handleHideModal}>
            <DidItModal
              aggregatedPinDataI={aggregatedPinDataId}
              isDoneByMe={isDoneByMe}
              loggedInUser={loggedInUser}
              onDoneStateChanged={this.onModalDoneStateChanged}
              pinId={pinId}
              pinTitle={pinTitle}
              userDidItDataId={userDidItDataId}
            />
          </LegacyModal>
        ) : null}
      </Fragment>
    );
  }
}

// $FlowFixMe: new errors found from flow 0.96 upgrade
export default withAuthenticatedAction(DidItButtonModalManager);
